/* ISYGIFTY v3 — theme.js — Parallax + Scroll Animations + Floating Header */
(function(){
'use strict';
const $=(s,c=document)=>c.querySelector(s);
const $$=(s,c=document)=>[...c.querySelectorAll(s)];
const on=(el,ev,fn,opts)=>el&&el.addEventListener(ev,fn,opts);
const fmt=c=>'€'+(c/100).toFixed(2).replace('.',',');

/* ══ FLOATING PILL HEADER ══ */
const hdr=$('.site-header');
let lastY=0,hdrTick=false;
if(hdr){
  window.addEventListener('scroll',()=>{if(!hdrTick){requestAnimationFrame(()=>{updateHeader();hdrTick=false;});hdrTick=true;}},{passive:true});
}
function updateHeader(){
  const y=scrollY;
  const annBar=document.querySelector('.ann-bar');
  const annH=annBar?annBar.offsetHeight:38;
  // scrolled = ann-bar has scrolled out of view
  hdr.classList.toggle('scrolled',y>annH+10);
  if(y>200){hdr.classList.toggle('hidden',y>lastY+4);}
  else{hdr.classList.remove('hidden');}
  lastY=y;
}

/* ══ SCROLL REVEAL ══ */
if('IntersectionObserver' in window){
  const io=new IntersectionObserver(entries=>{
    entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});
  },{threshold:0.07,rootMargin:'0px 0px -40px 0px'});
  $$('.reveal,.reveal--left,.reveal--right,.reveal--scale,.reveal--blur,.reveal--flip').forEach(el=>io.observe(el));
  // Heading underline draw
  $$('.heading').forEach(h=>{
    const io2=new IntersectionObserver(([e])=>{if(e.isIntersecting){h.classList.add('in');io2.unobserve(h);}},{threshold:.2});
    io2.observe(h);
  });
}

/* ══ HERO PARALLAX ══ */
const heroSection=$('.hero-section');
const heroCells=$$('.hero-grid-cell img');
const heroContent=$('.hero-content');
const heroBlobs=$$('.hero-blob');
if(heroSection){
  let heroTick=false;
  window.addEventListener('scroll',()=>{
    if(!heroTick){requestAnimationFrame(()=>{doParallax();heroTick=false;});heroTick=true;}
  },{passive:true});
  function doParallax(){
    const rect=heroSection.getBoundingClientRect(),vpH=window.innerHeight;
    if(rect.bottom<0||rect.top>vpH)return;
    const progress=-rect.top/vpH;
    heroCells.forEach((img,i)=>{
      const offset=progress*60*(i%2===0?1:-0.6);
      img.style.transform=`scale(1.12) translateY(${offset}px)`;
    });
    if(heroContent&&window.innerWidth>900){
      heroContent.style.transform=`translateY(${progress*-28}px)`;
    }
    heroBlobs.forEach((blob,i)=>{
      blob.style.transform=`translateY(${progress*(20+i*12)*(i%2===0?1:-1)}px)`;
    });
  }
}

/* ══ CURSOR GLOW (desktop) ══ */
if(window.matchMedia('(pointer:fine)').matches){
  const glow=document.createElement('div');
  glow.className='cursor-glow';
  document.body.appendChild(glow);
  let mx=0,my=0,cx=0,cy=0;
  document.addEventListener('mousemove',e=>{mx=e.clientX;my=e.clientY;});
  (function animGlow(){
    cx+=(mx-cx)*.12;cy+=(my-cy)*.12;
    glow.style.left=cx+'px';glow.style.top=cy+'px';
    requestAnimationFrame(animGlow);
  })();
  document.addEventListener('mouseover',e=>{
    glow.classList.toggle('big',!!e.target.closest('a,button,.btn,.prod-card,.occ-card,.review-card'));
  });
}

/* ══ READING BAR (PDP) ══ */
if(document.body.classList.contains('template-product')){
  const bar=document.createElement('div');
  bar.className='reading-bar';
  document.body.appendChild(bar);
  window.addEventListener('scroll',()=>{
    const d=document.documentElement,p=d.scrollTop/(d.scrollHeight-d.clientHeight)*100;
    bar.style.width=Math.min(100,p)+'%';
  },{passive:true});
}

/* ══ MOBILE DRAWER ══ */
const drawer=$('#mobile-drawer');
$$('[data-menu-open]').forEach(b=>on(b,'click',()=>{drawer?.classList.add('open');document.body.classList.add('no-scroll');}));
$$('[data-menu-close]').forEach(b=>on(b,'click',()=>{drawer?.classList.remove('open');document.body.classList.remove('no-scroll');}));
on(drawer?.querySelector('.mobile-drawer__bg'),'click',()=>{drawer?.classList.remove('open');document.body.classList.remove('no-scroll');});

/* ══ CART ══ */
const cartOv=$('#cart-overlay'),cartDr=$('#cart-drawer');
function openCart(){cartOv?.classList.add('open');cartDr?.classList.add('open');document.body.classList.add('no-scroll');fetchCart();}
function closeCart(){cartOv?.classList.remove('open');cartDr?.classList.remove('open');document.body.classList.remove('no-scroll');}
on(cartOv,'click',closeCart);
$$('[data-cart-close]').forEach(e=>on(e,'click',closeCart));
$$('[data-cart-open]').forEach(e=>on(e,'click',openCart));
window.ISYCart={open:openCart,close:closeCart};

async function fetchCart(){
  try{
    const cart=await fetch('/cart.js').then(r=>r.json());
    updateCount(cart.item_count);renderCart(cart);updateShip(cart.total_price/100);
  }catch(e){}
}
function updateCount(n){
  $$('[data-cart-count]').forEach(el=>{
    el.textContent=n;el.style.display=n>0?'flex':'none';
    if(n>0){el.classList.remove('updating');requestAnimationFrame(()=>el.classList.add('updating'));}
  });
}
function updateShip(t){$$('[data-ship-bar]').forEach(el=>el.classList.toggle('is-done',t>=100));
  const th=100,p=Math.min(100,(t/th)*100);
  $$('[data-ship-fill]').forEach(el=>el.style.width=p+'%');
  $$('[data-ship-rem]').forEach(el=>el.textContent='€'+Math.max(0,th-t).toFixed(0));
  $$('[data-ship-cur]').forEach(el=>el.textContent='€'+t.toFixed(0));
}
async function isyUpsell(cart){var zone=$("#cart-upsell-zone"),box=$("#cart-upsell-products");if(!zone||!box)return;if(!cart.items.length){zone.style.display="none";return}var pid=cart.items[0].product_id;var r=await fetch("/recommendations/products.json?product_id="+pid+"&limit=10&intent=related").then(x=>x.json()).catch(()=>null);if(!r||!r.products||!r.products.length){zone.style.display="none";return}var have={};cart.items.forEach(i=>{have[i.product_id]=1});var base=cart.items[0].price||0;var list=r.products.filter(p=>p.available&&!have[p.id]).sort((a,b)=>Math.abs(a.price-base)-Math.abs(b.price-base)).slice(0,6);if(!list.length){zone.style.display="none";return}box.innerHTML=list.map(p=>{var v=(p.variants||[]).filter(x=>x.available)[0];if(!v)return "";var img=p.featured_image||"";return '<div class="cart-up"><a class="cart-up__lk" href="'+p.url+'"><span class="cart-up__img">'+(img?'<img src="'+img+'" alt="" width="70" height="94">':"")+'</span><span class="cart-up__t">'+p.title+'</span></a><span class="cart-up__p">'+fmt(v.price)+'</span><button type="button" class="cart-up__b" data-vid="'+v.id+'">Aggiungi</button></div>'}).join("");zone.style.display="block";$$(".cart-up__b",box).forEach(b=>on(b,"click",async ev=>{ev.preventDefault();b.disabled=true;b.textContent="Aggiunto";await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:b.dataset.vid,quantity:1})});fetchCart()}))}function renderCart(cart){
  const c=$('#cart-items');if(!c)return;
  if(!cart.items.length){c.innerHTML=`<div style="text-align:center;padding:48px 0;color:var(--mist)"><div style="font-size:48px;margin-bottom:16px">🛍</div><div style="font-family:var(--display);font-size:22px;font-style:italic;color:var(--ink);margin-bottom:8px">Il carrello è vuoto</div><div style="font-size:13px">Scopri i brand firmati</div></div>`;return;}
  c.innerHTML=cart.items.map(i=>`<div class="cart-item-row"><div class="cart-item-img">${i.image?`<img src="${i.image}" alt="${i.title}" loading="lazy">`:`<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-family:var(--display);font-style:italic;font-size:14px;color:var(--blush)">${i.vendor.slice(0,4)}</div>`}</div><div style="flex:1"><span class="cart-item-brand">${i.vendor}</span><span class="cart-item-name">${i.product_title}</span>${i.variant_title&&i.variant_title!=='Default Title'?`<span class="cart-item-var">${i.variant_title}</span>`:''}<button type="button" class="qty-b cart-item-rm" data-key="${i.key}" data-a="dec" data-q="1" aria-label="Rimuovi">&times;</button><div class="cart-item-bottom"><span class="cart-item-price">${fmt(i.line_price)}</span><div class="qty-ctrl"><button class="qty-b" data-key="${i.key}" data-a="dec" data-q="${i.quantity}">−</button><span class="qty-n">${i.quantity}</span><button class="qty-b" data-key="${i.key}" data-a="inc" data-q="${i.quantity}">+</button></div></div></div></div>`).join('');
  $$('.qty-b',c).forEach(b=>on(b,'click',async()=>{const q=parseInt(b.dataset.q)+(b.dataset.a==='inc'?1:-1);await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:b.dataset.key,quantity:Math.max(0,q)})});fetchCart();}));
  try{isyUpsell(cart)}catch(e){}const tp=$('#cart-total-price');if(tp)tp.textContent=fmt(cart.total_price);
  // Show checkout button only when cart has items
  const chkBtn=$('#cart-checkout-btn');
  if(chkBtn) chkBtn.style.display = cart.items.length > 0 ? 'block' : 'none';
}
async function addToCart(vid,qty=1,props=null){
  const body={items:[{id:vid,quantity:qty}]};if(props)body.items[0].properties=props;
  try{await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});fetchCart();openCart();}catch(e){}
}
window.ISYCart.add=addToCart;

/* ══ BUY NOW — sync variant on size change ══ */
document.addEventListener('click',function(e){
  var sz=e.target.closest('.pdp-sz:not(.unavail)');
  if(!sz||!sz.dataset.variantId)return;
  var vid=sz.dataset.variantId;
  // Update buy-now form: remove old variant input, add new one
  var form=document.getElementById('buy-now-form');
  if(form){
    // Remove any existing updates[] inputs
    var old=form.querySelectorAll('input[name^="updates"]');
    old.forEach(function(i){i.remove();});
    // Add new one
    var inp=document.createElement('input');
    inp.type='hidden';
    inp.name='updates['+vid+']';
    inp.value='1';
    var bi=document.getElementById('pdp-buy-variant-id'); if(bi) bi.value=vid;
  }
});

/* ══ ATC ══ */
// Prevent PDP form from submitting (ATC is handled via JS/fetch)
const pdpForm=document.getElementById('pdp-form');
if(pdpForm) pdpForm.addEventListener('submit',function(e){ e.preventDefault(); });

document.addEventListener('click',async e=>{
  const btn=e.target.closest('[data-atc]');if(!btn)return;e.preventDefault();
  // Get variant: data-variant-id on button, OR active size selection, OR hidden input
  const activeSz=document.querySelector('.pdp-sz.active');
  const vid=activeSz?.dataset.variantId
    || btn.dataset.variantId
    || document.querySelector('[name="id"]')?.value;
  if(!vid){openCart();return;}
  const props=null;
  const orig=btn.innerHTML;btn.disabled=true;
  btn.innerHTML='<span style="display:inline-block;animation:spin .6s linear infinite">⟳</span>';
  await addToCart(vid,1,props);
  btn.innerHTML='✓ Aggiunto!';
  setTimeout(()=>{btn.innerHTML=orig;btn.disabled=false;},2200);
});
/* ── NEW PRODUCT CARD SIZE SELECTION ── */
document.addEventListener('click',e=>{
  const s=e.target.closest('.prod-sz');
  if(!s||s.classList.contains('prod-sz--out')) return;
  const card=s.closest('[data-product-card]');
  if(!card) return;
  card.querySelectorAll('.prod-sz').forEach(b=>b.classList.remove('active'));
  s.classList.add('active');
  // Update default variant for add button
  card.dataset.defaultVariant=s.dataset.variantId;
  // Update add btn price display if needed
});
/* Add btn on new card */
document.addEventListener('click',async e=>{
  const btn=e.target.closest('.prod-card__add-btn');if(!btn)return;
  const card=btn.closest('[data-product-card]');
  const active=card?.querySelector('.prod-sz.active');
  const vid=active?.dataset.variantId||card?.dataset.defaultVariant;
  if(!vid){openCart();return;}
  const orig=btn.textContent;btn.disabled=true;btn.textContent='...';
  await addToCart(vid,1);
  btn.textContent='✓ Aggiunto!';
  setTimeout(()=>{btn.textContent=orig;btn.disabled=false;},1800);
});
/* Legacy quick-add support */
document.addEventListener('click',e=>{const s=e.target.closest('.q-sz');if(!s||s.classList.contains('sold-out'))return;s.closest('.quick-sizes')?.querySelectorAll('.q-sz').forEach(b=>b.classList.remove('is-active'));s.classList.add('is-active');});
document.addEventListener('click',async e=>{const btn=e.target.closest('.quick-add-btn');if(!btn)return;const card=btn.closest('[data-product-card]');const active=card?.querySelector('.q-sz.is-active');const vid=active?.dataset.variantId||card?.dataset.defaultVariant;if(!vid){openCart();return;}btn.textContent='...';await addToCart(vid,1);btn.textContent='✓';setTimeout(()=>btn.textContent='+ Aggiungi',2000);});




/* ══ PDP SIZE/COLOR ══ */
document.addEventListener('click',e=>{const b=e.target.closest('.pdp-sz:not(.unavail)');if(!b||!b.closest('.pdp-size-grid'))return;b.closest('.pdp-size-grid').querySelectorAll('.pdp-sz').forEach(x=>x.classList.remove('active'));b.classList.add('active');// Sync buy-now form variant
const bni=document.getElementById('buy-now-variant-id');if(bni&&b.dataset.variantId)bni.value=b.dataset.variantId;// Update main ATC button variant
const mainAtc=$('[data-main-atc]');if(mainAtc&&b.dataset.variantId)mainAtc.dataset.variantId=b.dataset.variantId;// Update buy now button
const buyNow=$('#pdp-buy-now');if(buyNow&&b.dataset.variantId){buyNow.href='/checkout?'+b.dataset.variantId+':1';}// Update sticky
const sb=$('.pdp-sticky__btn');if(sb&&b.dataset.variantId)sb.dataset.variantId=b.dataset.variantId;const sp=$('.pdp-sticky__price');if(sp&&b.dataset.price)sp.textContent='€'+Math.round(parseInt(b.dataset.price)/100);});
document.addEventListener('click',e=>{const sw=e.target.closest('.pdp-csw');if(!sw)return;sw.closest('.pdp-color-grid').querySelectorAll('.pdp-csw').forEach(s=>s.classList.remove('active'));sw.classList.add('active');const el=$('[data-color-display]');if(el)el.textContent=sw.dataset.label;});
const mainAtc=$('[data-main-atc]'),stick=$('.pdp-sticky');
if(mainAtc&&stick)new IntersectionObserver(([e])=>stick.classList.toggle('hide',e.isIntersecting)).observe(mainAtc);

/* ══ GALLERY ══ */
const galMain=$('.pdp-gallery-main');
if(galMain){
  galMain.addEventListener('click',()=>galMain.classList.toggle('zoomed'));
  galMain.addEventListener('mousemove',e=>{if(!galMain.classList.contains('zoomed'))return;const img=galMain.querySelector('#gal-main');if(!img)return;const r=galMain.getBoundingClientRect();img.style.transformOrigin=`${e.clientX-r.left}px ${e.clientY-r.top}px`;});
}
document.addEventListener('click',e=>{const th=e.target.closest('.pdp-th');if(!th)return;const src=th.dataset.src;const main=$('#gal-main');if(main&&src){main.style.opacity='0';setTimeout(()=>{if(th.dataset.srcset){main.setAttribute('srcset',th.dataset.srcset);}else{main.removeAttribute('srcset');}main.src=src;main.style.opacity='1';},150);}th.closest('.pdp-thumbstrip').querySelectorAll('.pdp-th').forEach(t=>t.classList.remove('active'));th.classList.add('active');});

/* ══ GIFT WIDGET ══ */
document.addEventListener('click',e=>{const t=e.target.closest('[data-gift-toggle]');if(!t)return;const w=t.closest('.pdp-gift-widget');const isOn=w.dataset.active!=='true';w.dataset.active=String(isOn);const cb=w.querySelector('.pdp-gift-cb');if(cb){cb.textContent=isOn?'✓':'';cb.style.background=isOn?'var(--terracotta)':'var(--cream-3)';}w.querySelector('.pdp-gift-msg-area')?.classList.toggle('show',isOn);});
const gTA=$('.pdp-gift-textarea'),cC=$('.pdp-gift-char');
if(gTA&&cC)gTA.addEventListener('input',()=>cC.textContent=gTA.value.length+'/100');

/* ══ ACCORDION ══ */
$$('.pdp-accordion-trigger').forEach(btn=>{btn.addEventListener('click',()=>{const body=btn.nextElementSibling,isOpen=btn.classList.contains('open');$$('.pdp-accordion-trigger').forEach(b=>{b.classList.remove('open');b.setAttribute('aria-expanded','false');b.nextElementSibling.classList.remove('open');});if(!isOpen){btn.classList.add('open');btn.setAttribute('aria-expanded','true');body.classList.add('open');}});});

/* ══ COUNTDOWN ══ */
function getCountdown(){const now=new Date(),cut=new Date(now);cut.setHours(14,0,0,0);if(now>=cut)cut.setDate(cut.getDate()+1);const d=Math.max(0,cut-now),h=Math.floor(d/3600000),m=Math.floor((d%3600000)/60000),s=Math.floor((d%60000)/1000);const p=n=>String(n).padStart(2,'0');return{h:p(h),m:p(m),s:p(s)};}
const cdEls=$$('[data-countdown]'),urgCD=$('.pdp-urgency__cd');
if(cdEls.length||urgCD){const tick=()=>{const{h,m,s}=getCountdown();cdEls.forEach(t=>{const he=t.querySelector('[data-cd-h]'),me=t.querySelector('[data-cd-m]'),se=t.querySelector('[data-cd-s]');if(he)he.textContent=h;if(me)me.textContent=m;if(se)se.textContent=s;});if(urgCD)urgCD.textContent=`${getCountdown().h}:${getCountdown().m}:${getCountdown().s}`;};tick();setInterval(tick,1000);}

/* ══ GIFT FINDER ══ */
let gfData={};
window.gfNext=(step,val)=>{gfData['s'+step]=val;const cur=$('#gf-'+step);if(cur){cur.classList.remove('show');}const next=$('#gf-'+(step+1));if(next){next.classList.add('show');$$('.gf-dot').forEach((d,i)=>d.classList.toggle('active',i<=step+1));}else window.gfShowResult();};
window.gfShowResult=()=>{$$('.gf-step').forEach(s=>s.classList.remove('show'));$('#gf-result')?.classList.add('show');};
window.gfReset=()=>{gfData={};$$('.gf-step').forEach(s=>s.classList.remove('show'));$('#gf-result')?.classList.remove('show');$('#gf-0')?.classList.add('show');$$('.gf-dot').forEach((d,i)=>d.classList.toggle('active',i===0));};

/* ══ REVIEW TABS ══ */
$$('.review-tab').forEach(tab=>{on(tab,'click',()=>{const cat=tab.dataset.cat;tab.closest('.review-tabs').querySelectorAll('.review-tab').forEach(t=>t.classList.remove('active'));tab.classList.add('active');const container=tab.closest('[class*="section"],section');(container?$$('[data-review-cat]',container):$$('[data-review-cat]')).forEach(r=>{const show=cat==='all'||r.dataset.reviewCat===cat;if(show){r.style.display='block';requestAnimationFrame(()=>{r.style.opacity='1';r.style.transform='none';});}else{r.style.transition='opacity .25s,transform .25s';r.style.opacity='0';r.style.transform='translateY(8px)';setTimeout(()=>{if(r.style.opacity==='0')r.style.display='none';},280);}});});});

/* ══ LIVE TICKER ══ */
const purchases=[{name:'Giulia',city:'Milano',brand:'Hugo Boss',time:'3 min fa'},{name:'Marco',city:'Roma',brand:'Armani',time:'7 min fa'},{name:'Sara',city:'Torino',brand:'Calvin Klein',time:'12 min fa'},{name:'Andrea',city:'Napoli',brand:'D&G',time:'2 min fa'},{name:'Chiara',city:'Firenze',brand:'Liu Jo',time:'5 min fa'},{name:'Luca',city:'Bologna',brand:'North Face',time:'9 min fa'},{name:'Federica',city:'Venezia',brand:'Pinko',time:'1 min fa'},{name:'Lorenzo',city:'Bari',brand:'Balenciaga',time:'15 min fa'},{name:'Martina',city:'Palermo',brand:'K-Way',time:'4 min fa'},{name:'Riccardo',city:'Genova',brand:'Dsquared2',time:'11 min fa'}];
const ticker=$('#live-ticker');
if(ticker){let i=0;const show=()=>{const p=purchases[i%purchases.length];ticker.style.opacity='0';ticker.style.transform='translateY(8px)';setTimeout(()=>{ticker.innerHTML=`<span class="live-dot"></span><span><strong>${p.name}</strong> da ${p.city} ha acquistato <strong class="brand">${p.brand}</strong> · <small style="opacity:.7">${p.time}</small></span>`;ticker.style.transition='opacity .4s,transform .4s';ticker.style.opacity='1';ticker.style.transform='none';},200);i++;};show();setInterval(show,5000);}

/* ══ REVIEW LOAD MORE ══ */
const lmBtn=$('[data-load-reviews]');const hidRev=$$('.pdp-review-item[data-hidden]');
if(lmBtn&&hidRev.length){hidRev.forEach(r=>r.style.display='none');lmBtn.addEventListener('click',()=>{hidRev.forEach((r,idx)=>{r.style.display='block';r.style.opacity='0';r.style.transform='translateY(16px)';r.removeAttribute('data-hidden');setTimeout(()=>{r.style.transition='opacity .4s,transform .4s';r.style.opacity='1';r.style.transform='none';},idx*60);});lmBtn.style.display='none';});}

/* ══ FILTER PILLS ══ */
$$('.f-pill').forEach(p=>on(p,'click',()=>{$$('.f-pill').forEach(x=>x.classList.remove('active'));p.classList.add('active');}));

/* ══ SMOOTH SCROLL ══ */
document.addEventListener('click',e=>{const a=e.target.closest('a[href^="#"]');if(!a)return;const id=a.getAttribute('href');const target=$(id);if(target){e.preventDefault();target.scrollIntoView({behavior:'smooth',block:'start'});}});

/* ══ CSS KEYFRAMES INJECTION ══ */
const sty=document.createElement('style');
sty.textContent='@keyframes spin{to{transform:rotate(360deg)}}';
document.head.appendChild(sty);

/* ══ INIT ══ */
fetchCart();
})();

/* == pulizia emoji colorate dalla UI == */
(function(){var SEL='.review-tab,.pdp-review-item__product,.pdp-pay-badge,.ann-bar__item,.cart-checkout,.nav-gift,.pdp-del__icon,.pdp-how-step__icon,.guar-ico,.pdp-badge,.btn,.cart-drawer__empty,.f-qbtn';
var RE=/[\u{1F000}-\u{1FAFF}\u{2B00}-\u{2BFF}\u{FE0F}\u{1F900}-\u{1F9FF}]/gu;
function clean(root){try{(root||document).querySelectorAll(SEL).forEach(function(el){[].slice.call(el.childNodes).forEach(function(n){if(n.nodeType===3&&RE.test(n.nodeValue)){n.nodeValue=n.nodeValue.replace(RE,'').replace(/^\s+/,'');}});});}catch(e){}}
clean();document.addEventListener('DOMContentLoaded',function(){clean();});setTimeout(clean,1200);})();
/* == pulizia emoji colorate globale == */ (function(){var RE=/[\u{1F000}-\u{1FAFF}\u{FE0F}\u{26A1}\u{2728}\u{2764}\u{2B50}\u{2705}\u{274C}]/gu;function sweep(){try{var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT),n,hit=[];while(n=w.nextNode()){RE.lastIndex=0;if(RE.test(n.nodeValue))hit.push(n);}for(var i=0;i<hit.length;i++){var t=hit[i],p=t.parentNode;if(p&&(p.tagName==='SCRIPT'||p.tagName==='STYLE'))continue;t.nodeValue=t.nodeValue.replace(RE,'').replace(/\s{2,}/g,' ').replace(/^\s+/,'');}}catch(e){}}sweep();document.addEventListener('DOMContentLoaded',sweep);setTimeout(sweep,900);setTimeout(sweep,2200);document.addEventListener('click',function(){setTimeout(sweep,320);});})();